import {
  getFirestore,
  collection,
  doc,
  getDocs,
  query,
  orderBy,
  arrayUnion,
  updateDoc,
  getDoc,
  where,
  documentId,
  onSnapshot,
  setDoc,
  addDoc,
  getAggregateFromServer,
  sum,
  limit,
  or,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";
import { firestored, app } from "../firebase.config";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import moment from "moment";
import DatePicker from "react-horizontal-datepicker";

////////////////actual//////////////////////
const auth = getAuth();

export const saveuserdata = async (data, uid) => {
  return await setDoc(doc(firestored, "users", `${uid}`), data, { merge: true })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const savevehicledata = async (data, uid) => {
  return await setDoc(doc(firestored, "vehicles", `${uid}`), data, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const savereminderdata = async (data, uid) => {
  return await setDoc(doc(firestored, "reminders", `${uid}`), data, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const savetasksdata = async (data, uid) => {
  return await setDoc(doc(firestored, "supervisortasks", `${uid}`), data, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const userlogin = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      return user;
      // ...
    })
    .catch((err) => {
      return err;
    });
};

export const getuserinformation = async (collectionname, document) => {
  const items = await getDoc(query(doc(firestored, collectionname, document)));
  return items.data();
};

export const getprojectvehichles = async (collectionname, document) => {
  const items = await getDocs(
    query(
      collection(firestored, collectionname),
      where("createdby", "==", document),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getprojectvehichlesforsupervisors = async (
  collectionname,
  document,
) => {
  const items = await getDocs(
    query(
      collection(firestored, collectionname),
      where("assignedsupervisors", "array-contains", document),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const gettasksforsupervisors = async (collectionname, document) => {
  const items = await getDocs(
    query(
      collection(firestored, collectionname),
      where("employeelist", "array-contains", document),
      orderBy("deadlinetimestamp", "desc"),
    ),
  );

  return items.docs.map((doc) => doc.data());
};
export const gettasksoverview = async (collectionname, document) => {
  const items = await getDocs(
    query(
      collection(firestored, collectionname),
      where("projectid", "in", document),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const gettaskscreatedbysupervisors = async (
  collectionname,
  document,
) => {
  const items = await getDocs(
    query(
      collection(firestored, collectionname),
      where("createdby", "==", document),
      orderBy("deadlinetimestamp", "desc"),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllUserItems = async (table, parameter, comparison, value) => {
  const items = await getDocs(
    query(collection(firestored, table), where(parameter, comparison, value)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllSlotsWhere = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
  parameter2,
  comparison2,
  value2,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
      where(parameter2, comparison2, value2),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllSlotsWherex4 = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
  parameter2,
  comparison2,
  value2,
  parameter3,
  comparison3,
  value3,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
      where(parameter2, comparison2, value2),
      where(parameter3, comparison3, value3),
    ),
  );

  return items.docs.map((doc) => doc.data());
};
export const getAllSlotsWherex3 = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
  parameter2,
  comparison2,
  value2,
  parameter3,
  comparison3,
  value3,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
      where(parameter1, comparison1, value1),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllSlotsForChecking = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
      where("status", "==", "Accepted"),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllTripHistoryForChecking = async (
  table,
  parameter,
  comparison,
  value,
  id,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where("vehicleid", "==", id),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeandSupervisors = async (
  table,
  parameter,
  comparison,
  value,
  value2,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, "in", [value, value2]),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllSupervisors = async (
  table,
  parameter,
  comparison,
  value,
) => {
  const items = await getDocs(
    query(collection(firestored, table), where(parameter, "==", value)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeandSupervisorsforclient = async (
  table,
  parameter,
  comparison,
  value,
  value2,
  clientid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, "in", [value, value2]),
      where("createdby", "==", clientid),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllApprovedleaves = async (table, parameter, data) => {
  const items = await getDocs(
    query(collection(firestored, table), where(parameter, "in", data)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllCleanerShifts = async (table, cleanerid, date) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where("cleaningshiftid", "==", cleanerid),
      where("sheduleddate", "==", date),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeandSupervisorsforsupervisor = async (
  table,
  parameter,
  comparison,
  value,
  value2,
  creatorid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, "in", [value, value2]),
      where("createdby", "==", creatorid),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeForProject = async (
  table,
  parameter,
  comparison,
  value,
  projectid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where("projectassigned", comparison, projectid),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeForClient = async (
  table,
  parameter,
  comparison,
  value,
  projectid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where("createdby", comparison, projectid),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getallemployeesslotsdata = async (
  table,
  projectid,
  scheduledate,
  projectidlist,
) => {
  let data = [];
  let items = [];
  if (projectid == undefined) {
    items = await getDocs(
      query(
        collection(firestored, table),
        where("sheduleddate", "==", scheduledate),
        where("projectid", "in", projectidlist),
      ),
    );
  } else {
    items = await getDocs(
      query(
        collection(firestored, table),
        where("sheduleddate", "==", scheduledate),
        where("projectid", "==", projectid),
      ),
    );
  }
  items.docs.map((doc) => {
    if (doc.exists) {
      let newdata = doc.data();
      newdata["recordid"] = doc.id;
      data.push(newdata);
    }
  });
  return data;
};

export const getallexpressslotsdata = async (
  table,
  projectid,
  scheduledate,
  projectidlist,
  userid,
) => {
  let data = [];
  let items = [];
  if (projectid == undefined) {
    if (userid != "") {
      items = await getDocs(
        query(
          collection(firestored, table),
          where("sheduleddate", "==", scheduledate),
          where("projectid", "in", projectidlist),
          where("expressdelivery", "==", true),
          where("createdby", "==", userid),
        ),
      );
    } else {
      items = await getDocs(
        query(
          collection(firestored, table),
          where("sheduleddate", "==", scheduledate),
          where("projectid", "in", projectidlist),
          where("expressdelivery", "==", true),
        ),
      );
    }
  } else {
    if (userid != "") {
      items = await getDocs(
        query(
          collection(firestored, table),
          where("sheduleddate", "==", scheduledate),
          where("projectid", "==", projectid),
          where("expressdelivery", "==", true),
          where("createdby", "==", userid),
        ),
      );
    } else {
      items = await getDocs(
        query(
          collection(firestored, table),
          where("sheduleddate", "==", scheduledate),
          where("projectid", "==", projectid),
          where("expressdelivery", "==", true),
        ),
      );
    }
  }

  items.docs.map((doc) => {
    if (doc.exists) {
      let newdata = doc.data();
      newdata["recordid"] = doc.id;
      data.push(newdata);
    }
  });

  return data;
};

export const getallcarsbookingdata = async (table, date, vehiclelist) => {
  let data = [];
  let items = [];

  items = await getDocs(
    query(
      collection(firestored, table),
      where("sheduleddaterange", "array-contains", date),
      where("vehicleid", "in", vehiclelist),
    ),
  );

  items.docs.map((doc) => {
    if (doc.exists) {
      let newdata = doc.data();
      newdata["recordid"] = doc.id;
      data.push(newdata);
    }
  });
  return data;
};

export const getallvehicles = async (table, vehiclelist) => {
  let data = [];
  let items = [];

  items = await getDocs(
    query(collection(firestored, table), where("id", "in", vehiclelist)),
  );

  items.docs.map((doc) => {
    if (doc.exists) {
      let newdata = doc.data();
      newdata["recordid"] = doc.id;
      data.push(newdata);
    }
  });
  return data;
};

export const getallcleanerslotsdata = async (
  table,
  projectid,
  projectidlist,
) => {
  let data = [];
  let items = [];
  if (projectid == undefined) {
    items = await getDocs(
      query(
        collection(firestored, table),
        where("projectid", "in", projectidlist),
      ),
    );
  } else {
    items = await getDocs(
      query(collection(firestored, table), where("projectid", "==", projectid)),
    );
  }
  items.docs.map((doc) => {
    if (doc.exists) {
      let newdata = doc.data();
      newdata["recordid"] = doc.id;
      data.push(newdata);
    }
  });
  return data;
};

export const getAllProjectsforSupervisor = async (table, projectids) => {
  const items = await getDocs(
    query(collection(firestored, table), where("id", "in", projectids)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllChats = async (table) => {
  const items = await getDocs(collection(firestored, table));

  return items.docs.map((doc) => doc.data());
};

export const getAdminChats = async (table, id) => {
  const items = await getDocs(
    query(collection(firestored, table), where("admin", "==", id)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeTasks = async (
  table,
  parameter,
  comparison,
  value,
) => {
  const items = await getDocs(
    query(collection(firestored, table), where(parameter, comparison, value)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllVehicleSlots = async (
  table,
  parameter,
  comparison,
  value,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      orderBy("starttimetimestamp", "desc"),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeeslotfordate = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllEmployeesCleaningShifts = async (
  table,
  parameter,
  comparison,
  value,
) => {
  const items = await getDocs(
    query(collection(firestored, table), where(parameter, comparison, value)),
  );

  return items.docs.map((doc) => doc.data());
};

export const deleteDocument = async (table, docId) => {
  try {
    // Reference to the document
    const docRef = doc(firestored, table, docId.toString());

    // Delete the document
    await deleteDoc(docRef);

    return true;
  } catch (error) {
    console.error("Error deleting document: ", error);
    return false;
  }
};

export const getAllEmployeeTasksByOrder = async (
  table,
  parameter,
  comparison,
  value,
  orderparameter,
  ordertype,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where(parameter, comparison, value),
      orderBy(orderparameter, ordertype),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllBlogsPosts = async (table, orderparameter, ordertype) => {
  const items = await getDocs(
    query(collection(firestored, table), orderBy(orderparameter, ordertype)),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllVehiclesWhere = async (table, dataset) => {
  const items = await getDocs(
    query(collection(firestored, table), where("id", "in", dataset)),
  );

  return items.docs.map((doc) => doc.data());
};

export const gethighestWmployeeID = async (
  table,
  orderparameter,
  ordertype,
  id,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where("createdby", "==", id),
      orderBy(orderparameter, ordertype),
      limit(1),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllBlogsPostsAdmin = async (
  table,
  orderparameter,
  ordertype,
  adminid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where("admin", "==", adminid),
      orderBy(orderparameter, ordertype),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllBlogsPostsClient = async (
  table,
  orderparameter,
  ordertype,
  adminid,
) => {
  const items = await getDocs(
    query(
      collection(firestored, table),
      where("admin", "==", adminid),
      orderBy(orderparameter, ordertype),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getAllData = async (table) => {
  const items = await getDocs(query(collection(firestored, table)));

  return items.docs.map((doc) => doc.data());
};

export const saveitem = async (table, data) => {
  return await setDoc(doc(firestored, table, `${Date.now()}`), data, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const saveitemnew = async (table, data) => {
  return await setDoc(
    doc(firestored, table, data.schedulecreationdate.toString()),
    data,
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const saveitemwithid = async (table, id, data) => {
  return await setDoc(doc(firestored, table, id), data, { merge: true })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const updateItem = async (table, id, data) => {
  return await setDoc(doc(firestored, table, id.toString()), data, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const BatchUpdateItem = async (table, data, array) => {
  const batch = writeBatch(firestored); // Create a batch instance

  try {
    array.forEach((item, index) => {
      const docRef = doc(firestored, table, item.recordid); // Reference to each document
      batch.update(docRef, data); // Add update operation to batch
    });

    await batch.commit(); // Commit all updates at once
    console.log("Batch update successful!");
    return "success";
  } catch (error) {
    console.error("Error updating records:", error);
    return error;
  }
};

export const BatchEditItem = async (table, array) => {
  const batch = writeBatch(firestored); // Create a batch instance

  try {
    array.forEach((item, index) => {
      const docRef = doc(firestored, table, item.recordid); // Reference to each document
      batch.update(docRef, item); // Add update operation to batch
    });

    await batch.commit(); // Commit all updates at once
    console.log("Batch update successful!");
    return "success";
  } catch (error) {
    console.error("Error updating records:", error);
    return error;
  }
};

export const updateNestedItem = async (
  table,
  id,
  innertable,
  data,
  innerid,
) => {
  return await setDoc(
    doc(firestored, `${table}/${id}/${innertable}`, innerid.toString()),
    data,
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};
export const updateNestedArrayItem = async (
  table,
  id,
  innertable,
  data,
  innerid,
) => {
  return await setDoc(
    doc(firestored, `${table}/${id}/${innertable}`, innerid.toString()),
    { slots: arrayUnion(data) },
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const resetpassword = async (email) => {
  return await sendPasswordResetEmail(auth, email)
    .then((response) => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const updateNestedItemcheckout = async (
  table,
  id,
  innertable,
  data,
  innerid,
) => {
  return await setDoc(
    doc(firestored, `${table}/${id}/${innertable}/${innerid}`),
    data,
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const getNestedItem = async (table, id, innertable) => {
  const items = await getDocs(
    query(
      collection(firestored, `${table}/${id}/${innertable}`),
      orderBy("checkindatetime", "desc"),
      limit(1),
    ),
  );

  return items.docs.map((doc) => doc.data());
};

export const getSumofNestedItem = async (
  table,
  id,
  parameter,
  comparison,
  value,
  parametertwo,
  comparisontwo,
  valuetwo,
) => {
  const count = await getAggregateFromServer(
    query(
      collection(firestored, `${table}`),
      where(parameter, comparison, value),
      where(parametertwo, comparisontwo, valuetwo),
      where("employeeid", "==", id),
    ),
    {
      totalhours: sum("minutes"),
    },
  ).catch((err) => {
    console.log(err);
  });

  return count?.data().totalhours;
};

export const getSumofAllNestedItems = async (table, id) => {
  const count = await getAggregateFromServer(
    query(collection(firestored, `${table}`), where("employeeid", "==", id)),
    {
      totalhours: sum("minutes"),
    },
  ).catch((err) => {
    console.log(err);
  });

  return count?.data().totalhours;
};

export const getNestedItemdualcondition = async (
  table,
  id,
  parameter,
  comparison,
  value,
  parametertwo,
  comparisontwo,
  valuetwo,
  parameterthree,
  comparisonthree,
  valuethree,
) => {
  let items = [];
  if (valuethree != undefined) {
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        where(parameterthree, comparisonthree, valuethree),
        where("employeeid", "==", id),
      ),
    );
  } else {
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        where("employeeid", "==", id),
      ),
    );
  }

  return items.docs.map((doc) => doc.data());
};

export const getallnotificationswhere = async (
  table,
  parameter,
  comparison,
  value,
  parameter1,
  comparison1,
  value1,
) => {
  let items = [];

  items = await getDocs(
    query(
      collection(firestored, `${table}`),
      where(parameter, comparison, value),
      where(parameter1, comparison1, value1),
      orderBy("id", "desc"),
    ),
  );

  let array = items.docs.map((doc) => doc.data());

  return array;
};

export const getgeneralNestedItemdualcondition = async (
  table,
  id,
  parameter,
  comparison,
  value,
  parametertwo,
  comparisontwo,
  valuetwo,
  parameterthree,
  comparisonthree,
  valuethree,
) => {
  let items = [];
  if (valuethree != undefined) {
    // items = await getDocs(query(collection(firestored, `${table}`), where(parameter, comparison, value), where(parametertwo, comparisontwo, valuetwo), where(parameterthree, comparisonthree, valuethree), where("employeeid", "in", id)))
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        where(parameterthree, comparisonthree, valuethree),
        // orderBy("starttimetimestamp", "desc"),
      ),
    );
  } else {
    // items = await getDocs(query(collection(firestored, `${table}`), where(parameter, comparison, value), where(parametertwo, comparisontwo, valuetwo), where("employeeid", "in", id))).catch((err) => {
    //   console.log(err)
    // })
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        // orderBy("starttimetimestamp", "desc"),
      ),
    ).catch((err) => {
      console.log(err);
    });
  }

  let array = items.docs.map((doc) => doc.data());

  array = array.filter(function (itemdata) {
    return id.includes(itemdata.employeeid);
  });

  // .map(function (itemdata) {
  //   return itemdata;
  // })

  return array;
};

export const getgeneralNestedItemdualconditionvehiclesSupervisor = async (
  table,
  parameter,
  comparison,
  value,
  parametertwo,
  comparisontwo,
  valuetwo,
  parameterthree,
  comparisonthree,
  valuethree,
) => {
  let items = [];

  // // items = await getDocs(query(collection(firestored, `${table}`), where(parameter, comparison, value), where(parametertwo, comparisontwo, valuetwo), where(parameterthree, comparisonthree, valuethree), where("employeeid", "in", id)))
  items = await getDocs(
    query(
      collection(firestored, `${table}`),
      where(parameter, comparison, value),
      where(parametertwo, comparisontwo, valuetwo),
      where(parameterthree, comparisonthree, valuethree),
    ),
  );

  let array = items.docs.map((doc) => doc.data());

  return array;
};

export const getgeneralNestedItemdualconditionvehicles = async (
  table,
  parameter,
  comparison,
  value,
  parametertwo,
  comparisontwo,
  valuetwo,
  parameterthree,
  comparisonthree,
  valuethree,
  bool,
) => {
  let items = [];
  if (bool == true) {
    // // items = await getDocs(query(collection(firestored, `${table}`), where(parameter, comparison, value), where(parametertwo, comparisontwo, valuetwo), where(parameterthree, comparisonthree, valuethree), where("employeeid", "in", id)))
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        where(parameterthree, comparisonthree, valuethree),
      ),
    );
  } else {
    // items = await getDocs(query(collection(firestored, `${table}`), where(parameter, comparison, value), where(parametertwo, comparisontwo, valuetwo), where("employeeid", "in", id))).catch((err) => {
    //   console.log(err)
    // })
    console.log("this is the condition");
    items = await getDocs(
      query(
        collection(firestored, `${table}`),
        where(parameter, comparison, value),
        where(parametertwo, comparisontwo, valuetwo),
        where(parameterthree, comparisonthree, valuethree),
      ),
    ).catch((err) => {
      console.log(err);
    });
  }

  let array = items.docs.map((doc) => doc.data());

  return array;
};

export const saveitemwithkey = async (collection, key, chatdata) => {
  return await setDoc(doc(firestored, collection, key), chatdata, {
    merge: true,
  })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const saveitemwithkeynestedarray = async (
  parentcollection,
  parentkey,
  innercollection,
  childid,
  chatdata,
) => {
  return await doc(firestored, parentcollection, parentkey)
    .setDoc(doc(firestored, innercollection, childid), chatdata, {
      merge: true,
    })
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return err;
    });
};

export const getlivedata = async (collectionname, document) => {
  const items = await getDoc(
    onSnapshot(doc(firestored, collectionname, document)),
  );
  return items.data();
};

////////////////reference//////////////////////
//Saving new item

export const saveOrder = async (collection, data, orderdate) => {
  return await setDoc(
    doc(firestored, collection, `${orderdate}`),
    { orders: arrayUnion(data) },
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return "error";
    });
};

export const saveemployeetoproject = async (data, id) => {
  return await setDoc(
    doc(firestored, "TodaysOrders", `${id}`),
    { employees: arrayUnion(data) },
    { merge: true },
  )
    .then(() => {
      return "success";
    })
    .catch((err) => {
      return "error";
    });
};

//getall food items
export const getAllFoodItems = async (data) => {
  const items = await getDocs(
    query(collection(firestored, "foodItems"), orderBy("id", "desc")),
  );

  return items.docs.map((doc) => doc.data());
};

//getall users items

export const getAllOrderItems = async (date) => {
  const items = await getDocs(query(collection(firestored, "TodaysOrders")));
  // .where('timestamp', '>=', time)
  // .where('timestamp', '<=', lastdate)

  // where(documentId(), '==', "2022-11-28")
  // let data = items.docs.map((doc) => doc.data())
  //     return data;

  let data = items.docs
    .filter(function (doc) {
      return doc.id.includes(date);
    })
    .map(function (doc) {
      let newdata = doc.data();
      newdata["date"] = doc.id;

      return newdata;
    });
  return data;
};

export const updateUserstable = async (collection, document, jsonObject) => {
  return await setDoc(doc(firestored, collection, document), jsonObject, {
    merge: true,
  })
    .then((response) => {
      console.log(response);
      return "success";
    })
    .catch((err) => {
      console.log(err);
      return "error";
    });
};

export const CandidateForm = async (formData) => {
  try {
    const docRef = doc(collection(firestored, "candidate"));
    const docId = docRef.id;
    await setDoc(docRef, {
      ...formData,
      id: docId,
      createdAt: new Date(),
    });

    return { success: true, id: docId };
  } catch (error) {
    console.error("Error adding document: ", error);
    return { success: false, error: error.message };
  }
};

export const RequestQuoteForm = async (formData) => {
  try {
    const docRef = doc(collection(firestored, "quotation"));
    const docId = docRef.id;
    await setDoc(docRef, {
      ...formData,
      id: docId,
      createdAt: new Date(),
    });

    return { success: true, id: docId };
  } catch (error) {
    console.error("Error adding document: ", error);
    return { success: false, error: error.message };
  }
};

export const submitContactForm = async (formData) => {
  try {
    const docRef = doc(collection(firestored, "contact"));
    const docId = docRef.id;
    await setDoc(docRef, {
      ...formData,
      id: docId,
      createdAt: new Date(),
    });

    return { success: true, id: docId };
  } catch (error) {
    console.error("Error adding document: ", error);
    return { success: false, error: error.message };
  }
};
